export const blacklistedEmailDomains = new Set<string>([
  'hotmail.com',
  'gmail.com',
  'aol.com',
  'yahoo.com',
  'icloud.com',
  'comcast.com',
  'outlook.com',
  'zoho.com',
  'msn.com',
  'hotmail.co.uk',
  'sbcglobal.net'
]);

export function extractDomain(email: string | null | undefined): string | null {
  if (!email) return null;
  const atSymbolIndex = email.lastIndexOf('@');
  if (atSymbolIndex === -1) return null;
  return email.slice(atSymbolIndex + 1).trim().toLowerCase();
}

export function isBlockedEmailDomain(email: string): { isBlocked: boolean; domainName: string | null } {
  const domain = email.includes('@') ? extractDomain(email) : email.toLowerCase();
  if (!domain) return { isBlocked: false, domainName: null };
  return { isBlocked: blacklistedEmailDomains.has(domain), domainName: domain };
}
